import React from "react";

import { useDemographics } from "~/sdks/LocalDemographics/context";

import { SpokenLanguages } from "./SpokenLanguages";
import { MotherTongue } from "./MotherTongue";

import * as styles from "../styles";

export const Languages = () => {
  const {
    demographicsState: { official_language_knowledge: oficialLanguages },
  } = useDemographics();

  return (
    <div className={styles.graphLayoutWrapper}>
      {oficialLanguages && (
        <div className={styles.graphContainer} data-size={"half"}>
          <SpokenLanguages />
        </div>
      )}
      <div className={styles.graphContainer} data-size={"half"}>
        <MotherTongue />
      </div>
    </div>
  );
};
